module.exports = __webpack_public_path__ + "img/logo-vetorart.f73e51aa.jpg";